// Slim cross-browser scrollbar; pass the thumb color to suit the surface.
export const thinScrollbarSx = (thumbColor: string) => ({
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${thumbColor} transparent`,
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-thumb': { backgroundColor: thumbColor, borderRadius: 3 },
});
